import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonLink, ButtonExternal } from '../ui/Button';
import { EventCard } from '../events/EventCard';
import { DoodleSquiggle } from '../brand/Doodles';
import { upcomingEvents } from '../../data/events';
import { externalLinks } from '../../data/site';
export function UpcomingEvents() {
  return <Section className="relative overflow-hidden bg-brand-blue py-16 sm:py-20" labelledBy="events-heading" data-id="element-222" data-mp="pokehx7pql22">
      <DoodleSquiggle className="pointer-events-none absolute -right-6 top-8 h-10 w-40 opacity-70" color="var(--bcm-dark-blue)" data-id="element-223" data-mp="avqmjcb98cgi" />
      <Container data-id="element-224" data-mp="1xwr03lbdmue">
        <div className="max-w-2xl" data-id="element-225" data-mp="1ygbns2cmpc4">
          <h2 id="events-heading" className="font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-navy sm:text-5xl" data-id="element-226" data-mp="5ygppbljcyin">
            What’s happening at BCM
          </h2>
          <p className="mt-4 font-sans text-[17px] leading-relaxed text-ink" data-id="element-227" data-mp="3t3g1527o9e1s">
            Start with a worship night, join us during Welcome Week, or connect with someone who can
            help you find your place.
          </p>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-228" data-mp="34emg3nnbslbn">
          {upcomingEvents.map(event => <li key={event.id} className="h-full" data-id="element-229" data-mp="3ickv8v9h0ls7">
              <EventCard event={event} data-id="element-230" data-mp="3dfcd2uobohqy" />
            </li>)}
        </ul>

        <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-231" data-mp="2ppqarycnlmeq">
          <ButtonLink to="/events" data-id="element-232" data-mp="2pnx5onhova8u">See All Events</ButtonLink>
          <ButtonExternal href={externalLinks.getConnectedForm} variant="secondary" data-id="element-233" data-mp="2lpfvtw6vvlnq">
            Get Event Updates
          </ButtonExternal>
        </div>
      </Container>
    </Section>;
}